
import { useState, useEffect } from "react";
import { FaEdit, FaTrash } from "react-icons/fa";
import "./expenses.css";

export default function Expenses() {
  const [date, setDate] = useState("2026-01-19");
  const [category, setCategory] = useState("");
  const [amount, setAmount] = useState("");
  const [description, setDescription] = useState("");
  const [expenses, setExpenses] = useState([]);
  const [editId, setEditId] = useState(null);

  const API = "https://bodhimaram.onrender.com/api/expenses";

  // LOAD DATA
  useEffect(() => {
    loadExpenses();
  }, []);

  const loadExpenses = async () => {
    const res = await fetch(API);
    const data = await res.json();
    setExpenses(data);
  };

  const clearForm = () => {
    setCategory("");
    setAmount("");
    setDescription("");
    setEditId(null);
  };

  // ADD / UPDATE
  const addExpense = async () => {
    if (!category || !amount) return;

    const payload = {
      date,
      category,
      amount: Number(amount),
      description
    };

    if (editId) {
      // UPDATE
      await fetch(`${API}/${editId}`, {
        method: "PUT",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload)
      });
    } else {
      // ADD
      await fetch(API, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload)
      });
    }

    clearForm();
    loadExpenses();
  };

  // EDIT
  const handleEdit = (exp) => {
    setDate(exp.date);
    setCategory(exp.category);
    setAmount(exp.amount);
    setDescription(exp.description);
    setEditId(exp.id);
  };

  // DELETE
  const handleDelete = async (id) => {
    if (!window.confirm("Delete this expense?")) return;

    await fetch(`${API}/${id}`, {
      method: "DELETE"
    });

    loadExpenses();
  };

  const total = expenses.reduce((sum, e) => sum + Number(e.amount), 0);

  return (
    <div className="expense-wrapper">
      <h2 className="title expenseMobileTitle"> Expenses</h2>

      <div className="form-row  mobileExpenseForm">
        <label  className="form-grid-lab"  >Date:</label>
        <input 
          type="date" 
          value={date} 
          onChange={(e) => setDate(e.target.value)} 
        />
      </div>

      <div className="form-grid expenseMobileGrid ">
        <div>
          <label  className="form-grid-lab" >Category:</label>
          <select value={category} onChange={(e) => setCategory(e.target.value)}>
            <option value="">-- Select --</option>
            <option>Salary for teacher</option>
            <option>Salary for Workers</option>
            <option>Salary for cab</option>
            <option>Celebration</option>
            <option>Advance Payment</option>
            <option>Expenses for Materials</option>
            <option>Other</option>
            <option>Miscellaneous</option>
          </select>
        </div>

        <div>
          <label  className="form-grid-lab" >Amount:</label>
          <input
            type="number"
            value={amount}
            onChange={(e) => setAmount(e.target.value)}
          />
        </div>

        <div>
          <label  className="form-grid-lab" >Description:</label>
          <input
            type="text"
            value={description}
            onChange={(e) => setDescription(e.target.value)}
          />
        </div>
      </div>

      <button 
        className={`add-btn ${editId ? "active" : ""}`} 
        onClick={addExpense}
      >
        {editId ? "Update Expense" : "Add Expense"}
      </button>
<div className="mobileExpenseSummary">

  <div className="expenseSummaryLeft">

    <span>Total Expense</span>

    <h2>
      ₹{total.toLocaleString()}
    </h2>

  </div>

  <div className="expenseSummaryRight">

    {expenses.length}

    <span>Expenses</span>

  </div>

</div>


<div className="mobileExpenseList">

  {expenses.map((e) => (
<div className="mobileExpenseCard">

  <div className="mobileExpenseDateBox">

    <div className="mobileExpenseDay">
      {new Date(e.date).getDate()}
    </div>

    <div className="mobileExpenseMonth">
      {new Date(e.date).toLocaleString(
        "en-US",
        { month: "short" }
      )}
    </div>

    <div className="mobileExpenseYear">
      {new Date(e.date).getFullYear()}
    </div>

  </div>

  <div className="mobileExpenseInfo">

    <div className="mobileExpenseCategory">
      {e.category}
    </div>

    <div className="mobileExpenseDesc">
      {e.description}
    </div>

    <div className="mobileExpenseAmount">
      ₹{e.amount}
    </div>

  </div>

  <div className="mobileExpenseActions">

    <button
      className="edit-btn"
      onClick={() => handleEdit(e)}
    >
      <FaEdit />
    </button>

    <button
      className="delete-btn"
      onClick={() => handleDelete(e.id)}
    >
      <FaTrash />
    </button>

  </div>

</div>
   

  ))}

</div>

<div className="expense-table-wrap">
     <table className="expense-table">

        <thead>
          <tr>
            <th>Date</th>
            <th>Category</th>
            <th>Amount (₹)</th>
            <th>Description</th>
            <th>Actions</th>
          </tr>
        </thead>

        <tbody>
          {expenses.length === 0 ? (
            <tr>
              <td colSpan="5" className="empty">
                No expenses for this date.
              </td>
            </tr>
          ) : (
            expenses.map((e) => (
              <tr key={e.id} className={editId === e.id ? "row-active" : ""}>
<td>  {new Date(e.date).toLocaleString('en-GB')}</td>                 <td>{e.category}</td>
                <td>{e.amount}</td>
                <td>{e.description}</td>
                <td className="actions">
                  
                  {/* EDIT ICON */}
                  <button className="icon-btn edit-btn" onClick={() => handleEdit(e)}>
                    <FaEdit />
                  </button>

                  {/* DELETE ICON */}
                  <button className="icon-btn delete-btn" onClick={() => handleDelete(e.id)}>
                    <FaTrash />
                  </button>

                </td>
              </tr>
            ))
          )}
        </tbody>
      </table>

      <div className="total">
        Total Expense: ₹{total.toFixed(2)}
      </div>
    </div>
    </div>
  );
}
